
import '../css/App.css';
import 'react-block-ui/style.css';
import 'react-dual-listbox/lib/react-dual-listbox.css';
import '../css/omnichannel.css';

import React, { Component } from 'react';
import { Routes, Route } from 'react-router-dom';
import { Provider } from 'react-redux';
import BlockUi from 'react-block-ui';
import { withTranslation } from "react-i18next";
import CheckToken from '../middleware/CheckToken';
import SignalRService from '../controllers/SignalRService';
import store from '../redux/store';
import Interactions from './interactions/interactions';
import Login from './user/login';
import Main from './main';
import { setChatUrl, setEmail, setJanusParameters, setPasswordHashed, setPasswordRecovery, setDisableQueue, setPasswordPolicy, setShowDashboard, setPhoneLength, setShowInbox, setIntegrationScript, setAiEnabled } from '../redux/parametersSlice';
import Reports from './reports/reports';
import ChatWindow from './chat/chatwindow';
import HistoryChatWindow from './chat/historychatwindow';
import Contacts from './contacts/contacts';
import Dashboard from './dashboard/dashboard';
import esMessages from "devextreme/localization/messages/es.json";
import { locale, loadMessages } from "devextreme/localization";
import themes from "devextreme/ui/themes";
import Toastr from './utils/toastr';
import EventDispacherService from 'src/controllers/EventDispacherService';
import { notify } from './utils/utils';
import Extra from './extra/extra';

class App extends Component {

    constructor(props) {
        super(props)
        this.state = {
            loaded: false,
            script: ""
        };
        this.toastrRef = React.createRef();
        loadMessages(esMessages);
        locale(navigator.language.substring(0, 2));
        if (this.props.i18n.dir() === "rtl")
            document.dir = this.props.i18n.dir();
    }

    async componentDidMount() {

        await SignalRService.connect();
        let loggedIn = localStorage.getItem("fc-logged");
        this.mail = this.mail.bind(this);
        this.connectedResult = this.connectedResult.bind(this);
        this.connectionClosed = this.connectionClosed.bind(this);
        SignalRService.mail(this.mail);
        SignalRService.registerConnectedResult(this.connectedResult);
        SignalRService.registerConnectionClosed(this.connectionClosed);

        SignalRService.registerMailCredentials(res => {
            localStorage.setItem("faRCUser", res.mail);
            localStorage.setItem("faRCPwd", res.password);
        });

        if (loggedIn) {
            let data = JSON.parse(loggedIn);
            SignalRService.getApp({ userId: data.userId, extension: localStorage.getItem("faExtension") }, (error) => { });
            SignalRService.getMailCredentials({ userId: data.userId, extension: data.shortExtension }, (error) => { });
        }

        let theme = localStorage.getItem("faTheme");
        themes.current(`generic.${theme}.compact`);

        // Register the service worker
        const registerServiceWorker = async () => {
            if ("serviceWorker" in navigator) {
                try {
                    const registration = await navigator.serviceWorker.register(`sw.js?${window.CURRENT_CACHE}`);
                    if (registration.installing) {
                        console.log("Service worker installing");
                    } else if (registration.waiting) {
                        console.log("Service worker installed");
                    } else if (registration.active) {
                        console.log("Service worker active");
                    }
                } catch (error) {
                    console.error(`Registration failed with ${error}`);
                }
            }
        };

        try {
            await registerServiceWorker();
            console.log("Service worker registration process completed.");
        } catch (error) {
            console.error("Service worker registration process failed:", error);
        }
        console.log("This runs after the service worker registration is handled.");


    }
    

    mail(email) {

        store.dispatch(setEmail(email.enabled));
    }

    connectedResult(message) {

        store.dispatch(setChatUrl(message.chatServer));
        store.dispatch(setJanusParameters(message));
        store.dispatch(setPasswordHashed(message.passwordHashed));
        store.dispatch(setPasswordRecovery(message.passwordRecovery));
        store.dispatch(setDisableQueue(message.disableQueue));
        store.dispatch(setPasswordPolicy(message.passwordPolicy));
        store.dispatch(setShowDashboard(message.showDashboard));
        store.dispatch(setPhoneLength(message.phoneLength));
        store.dispatch(setShowInbox(message.inboxView)); //param 562
        store.dispatch(setIntegrationScript(message.integrationScript)); //param 467
        store.dispatch(setAiEnabled(message.aiEnabled)); //param 619
        
        let loggedIn = localStorage.getItem("fc-logged");
        if (loggedIn) {
            let data = JSON.parse(loggedIn);
            SignalRService.getApp({ userId: data.userId, extension: localStorage.getItem("faExtension") }, (error) => { });
        }
        
        if (message.roundcubeURL != null && message.roundcubeURL.length > 0) {
            localStorage.setItem("faRC", message.roundcubeURL);
        }

        this.setState({ loaded: true });

    }

    connectionClosed(message) {
        this.toastrRef.current.setType("error");
        this.toastrRef.current.setMessage(this.props.t("connectionlost") + (message === undefined ? "" : (": " + message)));
        this.toastrRef.current.show();
        notify("Fidelity Agent", this.props.t("connectionlost"), this.props.t("connectionlost"), `${window.location.origin}${window.location.pathname}/favicon.ico`);
    }

    render() {
        if (!this.state.loaded) {
            return (

                <BlockUi tag="div" blocking={!this.state.loaded} message={this.props.t("pleasewait")} color="#009ef7">
                    <div className="container" style={{ height: 960 }}></div>
                </BlockUi>

            )
        }
        return (
            <Provider store={store}>
                <Routes>
                    <Route path="login" element={<Login />} />
                    <Route path="main" element={<CheckToken><Main /></CheckToken>}>
                        <Route path="interactions" element={<CheckToken><Interactions></Interactions></CheckToken>} >
                            <Route path='chat' element={<ChatWindow />}></Route>
                            <Route path='onhold' element={<ChatWindow />}></Route>
                            <Route path='history' element={<HistoryChatWindow />}></Route>
                        </Route>
                        <Route path="reports" element={<CheckToken><Reports /></CheckToken>} />
                        <Route path="contacts" element={<CheckToken><Contacts /></CheckToken>} />
                        <Route path="dashboard" element={<CheckToken><Dashboard /></CheckToken>} />
                        <Route path="extra" element={<CheckToken><Extra /></CheckToken>} />
                    </Route>
                    <Route path="/" element={<CheckToken />} />
                </Routes>
                <Toastr ref={this.toastrRef} />
                <EventDispacherService />
            </Provider>

        );
    };
}

export default withTranslation()(App);


